import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Button, TextField, Typography as MuiTypography } from '@material-ui/core';
import { SearchInput } from 'components';
import Grid from '@material-ui/core/Grid';
import ToggleButton from '@material-ui/lab/ToggleButton';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';

const useStyles = makeStyles(theme => ({
  root: {},
  row: {
    display: 'flex',
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1)

  },
  search: {
    alignItems: 'center',
    marginTop: theme.spacing(3),
    marginRight: theme.spacing(1)
  },
  componentsSearch: {
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(3),
    marginRight: theme.spacing(1)
  },
  spacer: {
    flexGrow: 1
  },
  importButton: {
    marginRight: theme.spacing(1)
  },
  exportButton: {
    marginRight: theme.spacing(1)
  },
  searchInput: {
    marginRight: theme.spacing(1)
  }
}));

const FiliadoToolbar = props => {
  const {
    filiacaoStatus
  } = props;
  const { className, filterFiliados, ...rest } = props;
  const [filterValue, setFilterValue] = useState('');
  const [date01, setDate01] = useState(null);
  const [date02, setDate02] = useState(null);
  const [filiacaoStatusSelecionado, setFiliacaoStatusSelecionado] = useState('');
  const classes = useStyles();


  const handleChangeDate01 = date => {
    setDate01(date);
  };

  const handleChangeDate02 = date => {
    setDate02(date);
  };


  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <div className={classes.componentsSearch}>
        <Grid
          container
          spacing={2}
        >
          <Grid
            item
            md={4}
            xs={12}
          >
            <SearchInput
              className={classes.searchInput}
              placeholder="Pesquise pela nome, CPF ou número do CR"
              onChange={e => setFilterValue(e.target.value)}
              onKeyPress={(ev) => {
                if (ev.key === 'Enter') {
                  // Do code here
                  ev.preventDefault();
                  filterFiliados(filterValue, date01, date02);
                }
              }}
            />
          </Grid>
        <Grid
          item
          lg={2}
          md={2}
          xs={12}
        >
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Grid container justify="space-around">
              <KeyboardDatePicker
                fullWidth
                margin={'none'}
                inputVariant="outlined"
                orientation="landscape"
                id="vencimentoCrInicial"
                label="Data inicial"
                helperText={'Insira a data inicial para filtro de validade da mensalidade'}
                format="dd/MM/yyyy"
                size='small'
                value={date01}
                onChange={handleChangeDate01}
                onKeyPress={(ev) => {
                  if (ev.key === 'Enter') {
                    // Do code here
                    ev.preventDefault();
                    filterFiliados(filterValue, date01, date02);
                  }
                }}
                KeyboardButtonProps={{
                  'aria-label': 'change date',
                }}
                InputAdornmentProps={{ position: "end" }}
              />

            </Grid>
          </MuiPickersUtilsProvider>
        </Grid>
        <Grid
          item
          lg={2}
          md={2}
          xs={12}
        >
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Grid container justify="space-around">
              <KeyboardDatePicker
                fullWidth
                margin={'none'}
                inputVariant="outlined"
                orientation="landscape"
                id="vencimentoCrFinal"
                label="Data final"
                helperText={'Insira a data final para filtro de validade da mensalidade'}
                format="dd/MM/yyyy"
                size='small'
                value={date02}
                onChange={handleChangeDate02}
                onKeyPress={(ev) => {
                  if (ev.key === 'Enter') {
                    // Do code here
                    ev.preventDefault();
                    filterFiliados(filterValue, date01, date02);
                  }
                }}
                KeyboardButtonProps={{
                  'aria-label': 'change date',
                }}
                InputAdornmentProps={{ position: "end" }}
              />

            </Grid>
          </MuiPickersUtilsProvider>
        </Grid>
          <Grid
            item
            md={2}
            xs={12}
          >
            <FormControl variant="outlined" margin={'none'} fullWidth size={'small'}>
              <InputLabel id="demo-simple-select-outlined-label">Status</InputLabel>
              <Select
                fullWidth
                helperText="Status do filiado."
                label="Status"
                margin="dense"
                name="status_filiado"
                labelId="demo-controlled-open-select-label"
                value={filiacaoStatusSelecionado}
                onChange={e => setFiliacaoStatusSelecionado(e.target.value)}
                variant="outlined"
              >
                {filiacaoStatus.result.map((status, index) => (
                  <MenuItem key={index} value={status}>{status.descricao}</MenuItem>
                ))}

              </Select>
            </FormControl>

          </Grid>


          <Grid
            item
            md={2}
            xs={12}
          >
            <Button
              style={{width: '100%'}}
              color="primary"
              variant="contained"
              onClick={e => filterFiliados(filterValue, date01, date02, filiacaoStatusSelecionado.idFiliacaoStatus)}
            >
              Pesquisar
            </Button>
          </Grid>

        </Grid>
      </div>
    </div>
  );
};

FiliadoToolbar.propTypes = {
  className: PropTypes.string
};

export default FiliadoToolbar;
